import Api from "./Api";

export default {
  getAllDDList(payload) {
    let AllPortExpenseDD = Api().post(
      "Api_Master/getAllCommonMaster.php",
      payload
    );
    return AllPortExpenseDD;
  },
  getAllExpenseDDList(payload){
    let AllTPTDashReport = Api().post(
      "Api_TallyBilling/getTallyExpense.php",
      payload
    );
    return AllTPTDashReport;
  },
  getAllENQDDList(payload) {
    let AllENQDD = Api().post(
      "Api_Common/getDataCheck.php",
      payload
    );
    return AllENQDD;
  },

  

};



// WEBPACK FOOTER //
// ./src/services/CommonDDService.js